"use strict";

exports.__esModule = true;
exports.debounce = debounce;
exports.delay = delay;
exports.generateEventId = generateEventId;
exports.generateGUID = generateGUID;
exports.generateSpanId = generateSpanId;
exports.generateTraceId = generateTraceId;
exports.interceptFunction = interceptFunction;
var _is = require("./is");
/**
 * 劫持函数
 */
function interceptFunction(target, name, callback) {
  var registeredMethod = target[name];
  try {
    Object.defineProperty(target, name, {
      configurable: true,
      writable: true
    });
  } catch (e) {
    //
  }
  try {
    target[name] = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      callback.apply(this, args);
      if (registeredMethod) {
        return registeredMethod.apply(this, args);
      }
    };
  } catch (e) {
    //
  }
}

/**
 * @description: GUID v4
 * @return {String}
 */
function generateGUID() {
  var guid = '';
  try {
    if (crypto && crypto.randomUUID) {
      guid = crypto.randomUUID();
    } else if (crypto && crypto.getRandomValues) {
      var buf = new Uint8Array(16);
      crypto.getRandomValues(buf);
      buf[6] = buf[6] & 0x0f | 0x40; // version 4 UUID
      buf[8] = buf[8] & 0x3f | 0x80; // variant 10xxxxxx
      guid = buf.reduce(function (str, _byte) {
        return str + _byte.toString(16).padStart(2, '0');
      }, '').replace(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/, '\$1-\$2-\$3-\$4-\$5');
    }
  } catch (e) {
    //
  }
  if (!guid) {
    guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  }
  return guid;
}

/**
 * @description: 随机生成 traceId 或 sessionId
 * @return {String}
 */
function generateTraceId() {
  var traceId = generateGUID().replace(/-/g, '');
  // 适配OpenTracing 实现（long long转成16进制最高位不能为0）
  if (traceId[0] === '0') {
    traceId = '1' + traceId.substring(1);
  }
  if (traceId[16] === '0') {
    traceId = traceId.substring(0, 16) + '1' + traceId.substring(17);
  }
  return traceId;
}

/**
 * @description: 随机生成 spanId
 * @param len {number}
 * @param radix {number}
 * @return {String}
 */
function generateSpanId(len, radix) {
  if (len === void 0) {
    len = 16;
  }
  if (radix === void 0) {
    radix = 16;
  }
  var result = '';
  for (var i = 0; i < len; i++) {
    result += Math.floor(Math.random() * radix).toString(radix);
  }
  return result;
}

/**
 * @description: 随机生成 eventId
 * @param sessionId {string} sessionId
 * @return {String}
 */
function generateEventId(sessionId) {
  var spanId = generateSpanId();
  return "00-" + sessionId + "-" + spanId;
}

/**
 * @desc 函数防抖
 * @param func 回调函数
 * @param wait 延迟执行毫秒数
 */
function debounce(func, wait) {
  var timer;
  if (!(0, _is.isFunction)(func)) {
    return;
  }
  return function () {
    var context = this;
    var args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      func.apply(context, args);
    }, wait);
  };
}

/**
 * @desc 函数延迟执行
 * @param func 回调函数
 * @param wait 延迟执行毫秒数
 */
function delay(func, wait) {
  if (!(0, _is.isFunction)(func)) {
    return;
  }
  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }
  return setTimeout.apply(void 0, [func, +wait || 0].concat(args));
}